/**
 * @file Resolves the portal URL to show in an organization's outgoing emails.
 */

type LinkTemplates = {
  portalUrl?: string;
};

type Organization = {
  domain?: string;
  linkTemplates?: LinkTemplates;
};

// Prefers organization.linkTemplates.portalUrl when set so investor emails
// link to an external portal, otherwise falls back to the organization
// domain homepage. Keep this the same as the PORTAL_URL resolver in
// api-notifications/src/helpers/templates/getPortalUrl.js.
/**
 * Resolves the organization's portal URL, falling back to its domain homepage.
 */
const getPortalUrl = (organization: Organization = {}): string => {
  const { domain, linkTemplates = {} } = organization;
  const { portalUrl } = linkTemplates;

  const hasPortalUrl = Boolean(portalUrl);

  if (hasPortalUrl) {
    return portalUrl as string;
  }

  const hasDomain = Boolean(domain);

  if (!hasDomain) {
    return "";
  }

  const url = `https://${domain}`;

  return url;
};

export default getPortalUrl;
